import React from "react";
import { Button } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const DeleteButton = ({handleDeleteClick, isSaving, label, ...props}) => {
    return(
        <Button
            color="secondary" 
            variant="outlined"
            size="small"
            onClick={ () => handleDeleteClick()}
            disabled={isSaving}
            startIcon={<DeleteOutlineIcon />}
            {...props}
        >
             {label || "Удалить"}    
        </Button>
    )
}

export default DeleteButton;
